<template>
  <div class="booking-list">
    <div class="header">
      <div class="t-title xs mb-m">
        Bookings
        <div class="booking-hint">
          {{ bookingDisclaimer }}
        </div>
      </div>
      <SkeletonWrapper :isLoading="isLoading" v-if="totalPrice">
        <div class="total-section">
          <div class="t-copy travelers">
            <span>For All Travelers ({{ numberOfTravelers }})</span>
            <strong class="t-copy dark">
              {{ totalPrice }}
              <span class="asterix">*</span>
            </strong>
          </div>
          <div class="price-hint">
            Estimated total price for {{ bookings.flights.length ? 'flights and' : '' }} hotel
          </div>
        </div>
      </SkeletonWrapper>
    </div>
    <SkeletonWrapper :isLoading="isLoading" v-if="bookings.flights.length">
      <div class="booking-section">
        <h4>Flights</h4>
        <div class="group-flight" v-if="formattedGroupPrice">
          <h4 class="book-hint">Book the entire trip</h4>
          <BookingItem :isBookable="false" :withDropdown="false" :activity="flightGroup" />
        </div>
        <div class="flights-section">
          <h4 class="book-hint" v-if="formattedGroupPrice">or book segments separately</h4>
          <FlightBookingCard
            v-for="item in flights"
            :key="item.id"
            :flight="item"
            @book="onBookActivity(item.id, $event)"
          />
        </div>
      </div>
    </SkeletonWrapper>
    <SkeletonWrapper :isLoading="isLoading" v-if="bookings.stays.length">
      <div class="booking-section">
        <h4>Stays</h4>
        <BookingItem
          @book="onBookActivity(item.id, $event)"
          v-for="item in bookings.stays"
          :withDropdown="false"
          :key="item.id"
          :activity="item"
          totalPrice="Avg. Price per Night"
          additionalCaption="all rooms"
        />
      </div>
    </SkeletonWrapper>
    <SkeletonWrapper :isLoading="isLoading">
      <div class="booking-section" v-if="bookings.experiences.length > 0">
        <h4>Experiences</h4>
        <BookingItem
          @book="onBookActivity(item.id, $event)"
          v-for="item in bookings.experiences"
          :key="item.id"
          :activity="item"
        >
          <!-- <Dropdown :value="item.guests" category="Guests" :options="guestsOptions" v-if="item.url"/> -->
        </BookingItem>
      </div>
    </SkeletonWrapper>
    <SkeletonWrapper :isLoading="isLoading">
      <div class="booking-section" v-if="bookings.dining.length > 0">
        <h4>Dinings</h4>
        <BookingItem
          @book="onBookActivity(item.id, $event)"
          v-for="item in bookings.dining"
          :key="item.id"
          :activity="item"
        >
          <!-- <Dropdown :value="item.guests" category="Guests" :options="guestsOptions" v-if="item.url"/> -->
        </BookingItem>
      </div>
    </SkeletonWrapper>

    <SkeletonWrapper :isLoading="isLoading">
      <div
        class="booking-section nothing-to-book"
        v-if="
          !bookings.dining.length && !bookings.stays.length && !bookings.flights.length && !bookings.experiences.length
        "
      >
        <h4>Nothing to book yet</h4>
      </div>
    </SkeletonWrapper>
  </div>
</template>

<script>
import {useBookings} from './booking-list';
import BookingItem from './booking-item.vue';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import SkeletonWrapper from './skeleton-wrapper.vue'; // TODO: use skeleton from common components
import FlightBookingCard from '@common/flight-booking-card.vue';
Vue.use(VueCompositionAPI);
export default {
  name: 'BookingList',
  components: {BookingItem, SkeletonWrapper, FlightBookingCard},
  setup(_, root) {
    return {
      ...useBookings(root),
      guestsOptions: [1, 2, 3, 4].map((num) => ({
        label: `${num.toString()} People`,
        value: num,
        key: num,
        disabled: false,
      })),
      timeOptions: ['Time 1', 'Time 2', 'Time 3'].map((x) => ({label: x, value: x, key: x, disabled: false})),
      bookingDisclaimer:
        process.env.VUE_APP_BOOKING_DISCLAIMER ||
        'Once you’re ready to book, you’ll be redirected to AmexTravel.com where you can enjoy any travel benefits associated with your Card and, if eligible, use Membership Rewards® points at checkout.',
    };
  },
};
</script>

<style scoped lang="scss">
.booking-list {
  overflow-y: auto;
  height: 600px;
  padding: 0px 20px;
  margin-bottom: 10px;
}
.header {
  position: sticky;
  background-color: white;
  top: 0;
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
}
.header .travelers {
  white-space: nowrap;
}
.header .travelers span {
  display: inline-block;
  // margin-left: 6px;
}
.booking-section {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 10px;
}
.nothing-to-book {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.dropdown {
  --dropdown-border: none;
  padding: 8px 10px 8px 20px;
  background: #f7f7f7;
  border-radius: 20px;
  color: #071d3b;
  width: 120px;
  height: 48px;
}
.dropdown .value {
  font-size: 16px;
}
.asterix {
  position: relative;
  top: -5px;
  left: -4px;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
}
.booking-hint,
.price-hint {
  text-align: right;
  margin-right: 5px;
  font-style: normal;
  font-weight: 400;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  font-size: 10px;
  color: #566579;
}
.booking-hint {
  text-align: left;
}
</style>

<style scoped>
.group-flight + .flights-section {
  margin-left: 60px;
}
.book-hint {
  color: #a3abb6;
  font-weight: 400;
}
</style>
